import type { KeyboardEvent } from "react"

export type TabTone = "ask" | "new" | "ok" | "idle"
export interface SectionTab { id: string; label: string; tone: TabTone }

const WORD: Record<TabTone, string> = { ask: "needs input", new: "new", ok: "confirmed", idle: "" }

/** Horizontal tabs, one per section that has content. A dot says confirmed, needs input or new. */
export function SectionTabs({ tabs, selected, onSelect }: { tabs: SectionTab[]; selected: string; onSelect: (id: string) => void }) {
  const move = (e: KeyboardEvent, i: number) => {
    const d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0
    if (!d) return
    e.preventDefault()
    const next = tabs[(i + d + tabs.length) % tabs.length]
    onSelect(next.id)
    document.getElementById(`nsd-tab-${next.id}`)?.focus()
  }
  return (
    <div className="nsd-tabs" role="tablist" aria-label="Sections">
      {tabs.map((t, i) => (
        <button key={t.id} id={`nsd-tab-${t.id}`} type="button" role="tab" aria-selected={selected === t.id} aria-controls="nsd-panel"
          tabIndex={selected === t.id ? 0 : -1} className={`nsd-tab${selected === t.id ? " on" : ""}`}
          onClick={() => onSelect(t.id)} onKeyDown={(e) => move(e, i)}>
          <span className={`nsd-dot ${t.tone}`} aria-hidden="true" />
          {t.label}
          {WORD[t.tone] ? <span className="nsd-sr">, {WORD[t.tone]}</span> : null}
        </button>
      ))}
    </div>
  )
}
